/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const EasyOptionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="EasyOptionIcon">
    <path
      d="M1 10C1 5.02944 5.02944 1 10 1H16C20.9706 1 25 5.02944 25 10V16C25 20.9706 20.9706 25 16 25H10C5.02944 25 1 20.9706 1 16V10Z"
      stroke="var(--moreMenuIconFill)"
      strokeWidth="1.4"
    />
    <line x1="13" y1="9" x2="21" y2="9" stroke="#2894F9" strokeWidth="4" />
    <line
      x1="13"
      y1="17"
      x2="21"
      y2="17"
      stroke="var(--moreMenuIconFill)"
      strokeWidth="4"
    />
    <path
      d="M8.49999 18.086L10.182 16.404L10.889 17.111L7.99999 20L5.11099 17.111L5.81799 16.404L7.49999 18.086V14H8.49999V18.086Z"
      fill="var(--moreMenuIconFill)"
    />
    <path
      d="M8.49999 7.914L10.182 9.596L10.889 8.889L7.99999 6L5.11099 8.889L5.81799 9.596L7.49999 7.914V12H8.49999V7.914Z"
      fill="var(--moreMenuIconFill)"
    />
  </svg>
);

export default EasyOptionIcon;
